/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface WorkOrderSiteQueryReferenceDto {
  type?: WorkOrderSiteQueryReferenceDto.TypeEnum;
  id?: string;
  number?: string;
}
export namespace WorkOrderSiteQueryReferenceDto {
  export const TypeEnum = {
    Tag: 'TAG',
    Document: 'DOCUMENT',
  } as const;
  export type TypeEnum = (typeof TypeEnum)[keyof typeof TypeEnum];
}
